export default __webpack_public_path__ + "static/media/ch5-logo.113af865.png";